import { PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED, PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED } from './types';

export const photoSessionRescheduleConfirmOnClickAnalytics = ({ photoSessionId, newSessionType }) => ({
  type: PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED,
  extraProperties: {
    job_id: photoSessionId,
    new_session_type: newSessionType,
  },
});

export const photoSessionRescheduleSuccessViewedAnalytics = ({
  photoSessionId,
  samePhotographerResult,
}) => ({
  type: PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED,
  extraProperties: {
    job_id: photoSessionId,
    same_photographer_result: samePhotographerResult,
  },
});
